var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPdHydro({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#52CEFF",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M5.526 18.143c-.249.007-.461.208-.514.487-.052.279.068.563.292.687 0 0 1.138.683 2.394.683 1.047 0 1.861-.412 2.152-.57.292.158 1.106.57 2.153.57 1.048 0 1.862-.412 2.153-.57.291.158 1.105.57 2.153.57 1.256 0 2.393-.683 2.393-.683a.627.627 0 0 0 .297-.516.651.651 0 0 0-.24-.552.48.48 0 0 0-.538-.037s-1.015.552-1.912.552-1.912-.552-1.912-.552a.477.477 0 0 0-.482 0s-1.015.552-1.912.552-1.912-.552-1.912-.552a.477.477 0 0 0-.481 0s-1.015.552-1.912.552-1.912-.552-1.912-.552a.482.482 0 0 0-.26-.069z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12 15a4.978 4.978 0 0 0 3.717-1.656A5 5 0 1 0 12 15z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 3v2.998m4.95-.948-2.12 2.12M19 10h-2.998m.948 4.95-2.12-2.12m-7.78 2.12 2.12-2.12M5 10h2.998M7.05 5.05l2.12 2.12"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdHydro);
export default __webpack_public_path__ + "static/media/icon-pd-hydro.4b7ab24be350a26399e2aa23c0f23ca5.svg";
export { ForwardRef as ReactComponent };